var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BottomContent"},_vm._l((_vm.listData),function(v,i){return _c('div',{key:i,style:({ height: _vm.listData.length === 1 ? '100%' : '', width: _vm.listData.length === 1 ? '100%' : '', borderRightWidth: [3, 7].includes(i) ? 0 : '1px' })},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(v))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }